import React, {
    ReactElement,
} from "react";
import { Editor, Location, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import KeyboardEventHandler from "../keyboard-event-handler";
import { ToolbarList } from "../ToolbarList";
import EmojiList from "../../emoji-picker/emoji-short.json";

interface EmojiBarProps {
    editor: ReactEditor;
    keyboardEvents: KeyboardEventHandler
}

const STANDARD_REPLACEMENT_SET: Record<string, string> = {
    ":)": EmojiList[":slightly_smiling_face:"],
    ":D": EmojiList[":smile:"],
    ":(": EmojiList[":disappointed:"],
    ":'(": EmojiList[":cry:"],
};

export default function EmojiBar({ editor, keyboardEvents }: EmojiBarProps): ReactElement {
    const replaceTextResetState = (text: string, startSelection: Location) => {
        const range = startSelection ? Editor.range(editor, startSelection as Location, editor.selection?.anchor) : undefined;
        if (!range) {
            return;
        }
        Transforms.setSelection(editor, range);
        Transforms.delete(editor);
        if (startSelection) {
            Transforms.insertText(editor, `${text}`);
        }
    };

    const filter = (text: string) => {
        const search = text.startsWith(":") ? text.substring(1) : text;
        const newList = (search.length <= 1)
            ? []
            : Object.entries(EmojiList).filter(([key]) => key.toLowerCase().includes(search)).limit(10);
        return newList.map(([key, emoji]) => {
            const parts = key.split(search ?? "");
            return {
                value: emoji,
                label: (
                    <>
                        {emoji}
                        {" "}
                        {parts.map((val, partIndex) => (
                            <>
                                {val}
                                {partIndex < parts.length - 1 && (
                                    <strong>{search}</strong>
                                )}
                            </>
                        ))}
                    </>
                ),
            };
        });
    };

    return (
        <ToolbarList
            editor={editor}
            keyboardEvents={keyboardEvents}
            startKey=":"
            onSelected={replaceTextResetState}
            filter={filter}
            replacementSet={STANDARD_REPLACEMENT_SET}
        />
    );
}
